const assetAllocationHelper = {
  annualized_getSpecificData: ({
    data,
    key1 = "portfolio",
    key2 = "benchmark",
    percentage,
  }) => {
    const newArray = [];
    const p = percentage / 100;
    if (!data) return;
    for (let i in data) {
      let line = data[i];
      let fd = parseFloat(parseFloat(line.fund_return) * 1);
      let bm = parseFloat(parseFloat(line.bm_return) * 1);
      switch (line.metric_name) {
        case "1 Year":
          if (newArray.indexOf("1 Year") === -1)
            newArray.push({
              metric_name: "1 Year",
              [key1]: fd * p,
              [key2]: bm * p,
            });
          break;
        case "3 Year":
          if (newArray.indexOf("3 Year") === -1)
            newArray.push({
              metric_name: "3 Year",
              [key1]: fd * p,
              [key2]: bm * p,
            });
          break;
        case "5 Year":
          if (newArray.indexOf("5 Year") === -1)
            newArray.push({
              metric_name: "5 Year",
              [key1]: fd * p,
              [key2]: bm * p,
            });
          break;
        case "Since Inception":
          if (newArray.indexOf("Since Inception") === -1)
            newArray.push({
              metric_name: "Since Inception",
              [key1]: fd * p,
              [key2]: bm * p,
            });
          break;
        default:
      }
    }
    return newArray;
  },

  addGroupRect: ({ data }) => {
    let res = [];

    if (data && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        let obj = { ...data[i] };

        let p = (data[i]["portfolio"] * 100).toFixed(2) * 1;
        let b = (data[i]["benchmark"] * 100).toFixed(2) * 1;

        obj["portfolio"] = p;
        obj["benchmark"] = b;
        obj["groupRect"] = [
          {
            name: "portfolio",
            value: p,
          },
          {
            name: "benchmark",
            value: b,
          },
        ];

        res.push(obj);
      }
    }
    return res;
  },
};

export default assetAllocationHelper;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/asset_allocation_funds/helper.js